const postChildRoutes = (prop, mode = false) => [
  {
    path: '',
    name: `${prop}.list`,
    meta: {
      authRequired: mode,
      title: 'Posts'
    },
    component: () => import('../views/pages/post/list.vue')
  },
  {
    path: ':postId',
    name: `${prop}.detail`,
    meta: {
      authRequired: mode,
      title: ''
    },
    component: () => import('../views/pages/post/detail.vue')
  }
]

export default postChildRoutes
